<div class="position-relative d-flex flex-column h-100  text-grey"
cdkDrag cdkDragRootElement=".cdk-overlay-pane"
cdkDragBoundary="body"
[cdkDragDisabled]="!toogleDialog">
<div class="modal-header jobDialogHeader text-grey" cdkDragHandle>
  <h4 class="modal-title synchpc-primary" id="modal-title">
    Create Repository
  </h4>
  <i
  style="z-index: 1"
  class="bi bi-dash text-danger"
  [ngClass]="{
    'bi-dash-lg': !toogleDialog,
    'bi-fullscreen': toogleDialog,
    'minmax-dialog': toogleDialog
  }"
  color="warn"
  (click)="toogleDialogMinMax()"
  [title]="toogleDialog ? 'Maximize' : 'Minimize'"
  ></i>
  <i
  style="z-index: 1"
  class="bi bi-x-lg text-danger mx-3"
  color="warn"
  (click)="onCancel()"
  title="Close"
  ></i>
</div>
<div class="modal-body jobDialogBody text-grey">
  <form
    name="createRepositoryForm"
    [formGroup]="createRepositoryForm"
    autocomplete="off"
    spellcheck="false"
  >
  <div class="h-100 d-flex flex-column">
    <div class="flex-grow-1">
      <div class="form-row">
        <div class="form-col">
          <mat-form-field >
            <mat-label>Repository Name</mat-label>
            <input
            matInput
            maxlength="36"
            placeholder="Repository Name"
            formControlName="name"
            />
            <mat-error
              *ngIf="createRepositoryForm.get('name')?.hasError('required') && createRepositoryForm.get('name')?.touched">
              Repository name is required
            </mat-error>
          </mat-form-field>
        </div>
        <div class="form-col">
          <mat-form-field >
            <mat-label>Registry Host</mat-label>
            <input
            matInput
            maxlength="20"
            placeholder="localhost:5555"
            formControlName="registryHost"
            />
            <mat-error
              *ngIf="createRepositoryForm.get('registryHost')?.hasError('required') && createRepositoryForm.get('registryHost')?.touched">
              Registry host is required
            </mat-error>
          </mat-form-field>
        </div>
      </div>
  </div>
</div>
</form>
  
</div>
<div class="modal-footer jobDialogFooter text-grey">
  <div class="w-100 d-flex align-items-center">
    <div class="d-flex d-flex justify-content-end w-100">
      <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="onCancel()"
      >
      Close
    </button>
    <button
    type="button"
    class="btn btn-primary ms-2"
    (click)="createRepository()"
    >
    Submit
  </button>
</div>
</div>
</div>
<ngx-spinner
bdColor="rgba(0,0,0,0)"
size="default"
zIndex="1"
color="var(--s-primary-color)"
type="ball-spin"
[fullScreen]="false"
name="createRepositorySpinner"
>
<p class="pleaseWait text-grey">Please wait ...</p>
</ngx-spinner>
</div>
